<template>
  <v-form>

    <v-simple-table>
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left" style="max-width: 100px">Event Name</th>
          <th class="text-left">Fee</th>
          <th class="text-left">Choice</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(extraProduct, index) in state.member.meeting.extraProducts" :key="'extrap-'+index"
            class="">
          <td class="text-left">
            {{ extraProduct.name }} <br>
            <small><em>{{ extraProduct.desc }}</em></small>
          </td>
          <td class="text-left">{{
              new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency:
                    'USD'
              }).format(extraProduct.price)
            }}
          </td>

          <td class="text-left">

            <v-checkbox v-model="state.member.meeting.extraProductsSelected"
                        :value="extraProduct" ></v-checkbox>


            <div v-if="extraProduct.multiple === '1'">

              <v-select v-if="extraProduct.name === 'Splash Bash Family Friendly Event'"
                  attach
                  label="RSVP Quantity (type or click desired quantity)"
                  prepend-icon="mdi-account-multiple-check"
                  v-model="extraProduct.quantity"
                  :items=rsvpFour
              ></v-select>
              <v-select v-else
                  attach
                  label="RSVP Quantity (type or click desired quantity)"
                  prepend-icon="mdi-account-multiple-check"
                  v-model="extraProduct.quantity"
                  :items=rsvpQuantity
              ></v-select>
              <v-text-field
                  label="RSVP Name(s)"
                  name="rsvp-names"
                  prepend-icon="mdi-account"
                  type="text"
                  v-model="extraProduct.rsvp_names"
                  required
              ></v-text-field>

            </div>
            <div v-else>
              <v-select
                  attach
                  label="RSVP Quantity (type or click desired quantity)"
                  prepend-icon="mdi-account-multiple-check"
                  v-model="extraProduct.quantity"
                  :items=rsvpOne
              ></v-select>
              <v-text-field
                  label="RSVP Name(s)"
                  name="rsvp-names"
                  prepend-icon="mdi-account"
                  type="text"
                  v-model="extraProduct.rsvp_names"
                  required
              ></v-text-field>
            </div>
          </td>
        </tr>
        <tr v-if="optionExtraSelected.isGolfT" >
          <MulliganPack />
        </tr>

        </tbody>
      </template>
    </v-simple-table>
  </v-form>
</template>

<script>

import {mapGetters} from 'vuex'
import MulliganPack from "@/components/MulliganPack"
export default {
  name: "ExtraProducts",
  data: function () {
    return {
      rsvpQuantity: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10
      ],
      rsvpOne: [
        1
      ],
      rsvpFour: [
        1,
        2,
        3,
        4
      ]
    }
  },
  components: {
    MulliganPack
  },
  computed: {
    ...mapGetters({
      state: 'getState',
    }),
    optionExtraSelected: function () {
      let isGolfT;
      this.state.member.meeting.extraProductsSelected.filter((namep) => {
        let name = namep.name;
        if (name == "Golf Tournament") {
          isGolfT = true;
        }
      });

      return{
        isGolfT: isGolfT
      }
    }

  },

}
</script>

<style scoped>

</style>